module.exports = __webpack_public_path__ + "static/media/study 220216.e05b4002.png";